import { render, staticRenderFns } from "./EvaluationTable.vue?vue&type=template&id=1908f5fb&scoped=true"
import script from "./EvaluationTable.vue?vue&type=script&lang=js"
export * from "./EvaluationTable.vue?vue&type=script&lang=js"
import style0 from "./EvaluationTable.vue?vue&type=style&index=0&id=1908f5fb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1908f5fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1908f5fb')) {
      api.createRecord('1908f5fb', component.options)
    } else {
      api.reload('1908f5fb', component.options)
    }
    module.hot.accept("./EvaluationTable.vue?vue&type=template&id=1908f5fb&scoped=true", function () {
      api.rerender('1908f5fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/evaluation/components/EvaluationTable.vue"
export default component.exports